import React, { useCallback, useEffect, useState } from "react";
import { Link, useNavigate, useLocation, useSearchParams } from "react-router-dom";
import {
  Alert,
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Checkbox,
  Container,
  Divider,
  FormControlLabel,
  Grid2,
  Link as MuiLink,
  TextField,
  Typography
} from '@mui/material';
import { useAuth } from '../../AuthContext';
import { TERMS_URL, EMAIL_REGEX } from "../../constants";

function formDataToJSON(formData) {
  const object = {};
  formData.forEach((value, key) => {
    object[key] = value === 'on' ? true : value;
  });
  return object;
}

export default function AccountRemoval() {
  let auth = useAuth();

  const [userEmail, setUserEmail] = useState('');
  const [formError, setFormError] = useState({});
  const [isPending, setIsPending] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleSubmit = useCallback((event) => {
    event.preventDefault();
    setFormError({});
    
    let formData = new FormData(event.currentTarget);
    const data = formDataToJSON(formData);
    
    if (!data.email?.length || !EMAIL_REGEX.test(data.email)) {
      setFormError({ email: 'Please enter a valid email address' });
      return;
    }
    setFormError({});
    setIsPending(true);

    auth.request('/api/user/removal-request', data).then((response) => {
      console.log('Request submitted!', response);
      if (response.status !== 200) {
        throw new Error(response.data.error || 'An error occurred. Please contact support.');
      }
      setIsSubmitted(true);
    }).catch(error => {
      console.log('Error', error);
      setFormError({ response: error.message });
      setIsPending(false);
    });
  }, []);


  return (
    <Container maxWidth="sm" sx={{ p: 3 }}>
      <Typography variant="h3">Request Account Deletion</Typography>

      {isSubmitted ? (
        <Alert sx={{ my: 3 }} severity="success">
          Your request has been submitted. Please allow up to 48 hours for your account and data to be deleted. You should receive a confirmation email shortly.
        </Alert>  
      ) : (
        <React.Fragment>
          <Typography variant="body2" color="textSecondary" sx={{ my: 3 }}>
            Complete this form to submit your request for account deletion. We will review and delete your account and any associated data within 48 hours.
          </Typography>
          
          <Alert sx={{ my: 3 }} severity="warning">This will delete all account data and purchase history and cannot be undone. For refunds on in-app purchases, contact the Apple App Store or Google Play store.</Alert>
          
          <form onSubmit={handleSubmit}>
            <Grid2 container direction="column" spacing={3}>
              <Grid2>
                <TextField
                  name="email"
                  label="Email Address"
                  fullWidth={true}
                  required={true}
                  error={formError.email}
                  disabled={isPending}
                  onChange={(e) => setUserEmail(e.target.value)}
                  value={userEmail}
                  helperText={formError.email}
                />
              </Grid2>
              <Grid2>
                <FormControlLabel
                  required={true}
                  disabled={isPending}
                  control={<Checkbox name="acknowledge" />}
                  label={'I understand this permanently deletes my account, data, and purchased content'}
                />
              </Grid2>
            </Grid2>
            <Button type="submit" sx={{ mt: 2 }} variant="outlined" disabled={isPending}>Submit Request</Button>

            
            {formError.response ? (
              <Alert sx={{ mt: 3 }} severity="error">{formError.response}</Alert>
            ) : null}
          </form>
        </React.Fragment>
      )}

    </Container>
  );
}
